import React from 'react';

import useAnalytics from '@/components/Analytics/hooks/useAnalytics';
import { TrackEvent } from '@/components/Analytics/types';

import Link from './Link';

type TrackLinkProps = React.ComponentProps<typeof Link> & {
  track: TrackEvent;
};

export default function TrackableLink(props: TrackLinkProps) {
  const { track: propsTrack, onClick: onClickProps, ...otherProps } = props;
  const { track } = useAnalytics();

  const onClick = React.useCallback(
    (event: any) => {
      onClickProps?.(event);
      track(propsTrack.event, propsTrack.properties);
    },
    [onClickProps, propsTrack.event, propsTrack.properties, track],
  );

  return <Link {...otherProps} onClick={onClick} />;
}
